import { Suspense, useEffect, useState } from "react";
import { getCompanyId } from "../../../common/services/company.api";
import { useToastContext } from "../../../common/components/ui/toast/toast.context";
import {
  TableFilters,
  TableFiltersState,
} from "../../../common/components/ui/table/TableFilters";
import Loading from "../../../common/components/ui/loading/Loading";
import GenericTable from "../../../common/components/ui/table/GenericTable";
import { formatDateAndTime } from "../../../common/helpers/date.helpers";
import TableFooter from "../../../common/components/ui/table/TableFooter";
import { IStockTable } from "../../../types/stock.types";
import { getStocks } from "../../../common/services/stock.api";
import { useNavigate } from "react-router-dom";

const headers = {
  productCode: "Código",
  productName: "Descrição",
  minimumQuantity: "Quantidade mínima",
};

function TableNfs() {
  const companyId = getCompanyId();
  const { notifyError } = useToastContext();
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState({ itemsPerPage: 10, totalItems: 0 });
  const [stocks, setStocks] = useState<IStockTable[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: [],
  });

  useEffect(() => {
    async function laodNfs() {
      setIsLoading(true);

      const result = await getStocks({
        search: filters.search,
        status: filters.status,
        page,
      });

      setData({
        itemsPerPage: data.itemsPerPage,
        totalItems: result.totalItems,
      });

      if (result && !result.ok) {
        notifyError(
          (result as { message?: string })?.message || "unknown error"
        );
        return;
      }

      setData({
        itemsPerPage: data.itemsPerPage,
        totalItems: result.totalItems,
      });
      setStocks(result.data);
      setIsLoading(false);
    }

    laodNfs();
  }, [filters, page, companyId, data.itemsPerPage, notifyError]);

  const handleFilterChange = (newFilters: Partial<TableFiltersState>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  return (
    <Suspense fallback={<Loading />}>
      <div className="table-section">
        <TableFilters
          dashboardHeader="Notas Fiscais"
          placeholder="Digite a descrição, o código ou o e-mail do solicitante."
          statusOptions={{}}
          newItemLabel="Novo Cliente"
          onNewItemClick={() => {}}
          onSearch={handleFilterChange}
          entity="stocks"
          tableData={stocks}
        />

        <GenericTable
          headers={headers}
          data={stocks}
          setFilters={({ orderBy }) => {
            setFilters((prevFilters) => ({
              ...prevFilters,
              orderBy,
            }));
          }}
          renders={
            {
              productCode: (code, data) => (
                <a
                  href={`/nfs/${(data as IStockTable)._id}`}
                  onClick={(e) => {
                    e.preventDefault(); // Para evitar o comportamento padrão do link
                    navigate(`/nfs/${(data as IStockTable)._id}`); // Navegação na mesma página
                  }}
                  target="_blank" // Abre em uma nova aba
                  rel="noopener noreferrer" // Melhoria de segurança
                >
                  {code as string}
                </a>
              ),
              updatedAt: formatDateAndTime,
              createdAt: formatDateAndTime,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } as any
          }
          entity="stocks"
        />

        {isLoading && <Loading />}

        <TableFooter
          page={page || 1}
          totalItems={data.totalItems || 0}
          itemsPerPage={+(filters.itemsPerPage ?? 10)}
          goToPage={setPage}
        />
      </div>
    </Suspense>
  );
}

export default TableNfs;
